import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-use';
import { TrackEvent } from '@alycecom/services';

export default () => {
  const { trackEvent } = TrackEvent.useTrackEvent();
  const state = useLocation();

  const commonOptions = useMemo(
    () => ({
      ref: state.pathname,
    }),
    [state],
  );

  return useCallback(
    (eventName, payload = {}, options = {}) => {
      trackEvent(eventName, payload, { ...commonOptions, ...options });
    },
    [trackEvent, commonOptions],
  );
};
